import { EmploymentReportStatusViewModel } from '@fora-monorepo/employer-my-pages-common/types';

export const mockEmploymentReportsStatus: EmploymentReportStatusViewModel = {
  isEmploymentReportProcessing: false,
  latestProcessedReportHasDeviationsAndNoPayrollData: {
    adminReporterFullName: 'Fora',
    createdDate: '2023-03-14T13:00:00',
    hasDeviations: true,
    hasInformation: true,
    payrollReportId: 'A33BB92E99751EDE9CSTT9965EC7555',
    source: 'Fora',
    status: 'Processed',
    successfullyProcessedDate: '2024-02-15T13:00:00',
  },
  latestProcessedReportHasInformationAndNoPayrollData: {
    adminReporterFullName: 'Fora',
    createdDate: '2023-03-14T13:00:00',
    hasDeviations: true,
    hasInformation: true,
    payrollReportId: 'A33BB92E99751EDE9CSTT9965EC7555',
    source: 'Fora',
    status: 'Processed',
    successfullyProcessedDate: '2024-02-15T13:00:00',
  },
};
